<template>
    <div class="flash-holder">
        <div
            v-for="(notice, i) in flashInfo"
            :key="i"
            :class="['alert', 'alert-' + notice.state]"
            :style="`width: ${width}px`"
        >
            <div class="alert-icon-container">
                <img v-if="notice.state === 'danger'" src="@/assets/images/danger.svg" alt="">
                <img v-if="notice.state === 'success'" src="@/assets/images/success.svg" alt="">
                <img v-if="notice.state === 'warning'" src="@/assets/images/warning.svg" alt="">
                <img v-if="notice.state === 'info'" src="@/assets/images/info.svg" alt="">
                <img v-if="notice.state === 'clock'" src="@/assets/images/clock.svg" alt="">
            </div>
            <div class="alert-message-container">
                <h2 class="alert-title">{{ notice.title }}</h2>
                <p>{{ notice.message }}</p>
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton";

export default {
    name: "Flash",
    components: { VButton },
    data() {
        return {
            flashInfo: [],
            time: 4500,
        };
    },
    props: {
        bottom: {
            type: Boolean,
            default: false
        },
        width: {
            type: Number,
            default: 325
        }
    },
    methods: {
        showFlashSuccess(message, time) {
            this._addFlash({
                message,
                time,
                title: 'Success',
                state: "success",
            });
        },
        showFlashError(message, time) {
            this._addFlash({
                message,
                time,
                title: 'Error',
                state: "danger",
            });
        },
        showFlashWarning(message, time) {
            this._addFlash({
                message,
                time,
                title: 'Warning',
                state: "warning",
            });
        },
        showFlashInfo(message, time) {
            this._addFlash({
                message,
                time,
                title: 'Info',
                state: "info",
            });
        },
        showLogworkFlash(message, time) {
            this._addFlash({
                message,
                time,
                title: 'Time',
                state: "clock",
            });
        },
        _addFlash({ message, time, title, state }) {
            this.flashInfo.unshift({ message, title, state });

            setTimeout(() => {
                this.flashInfo.pop();
            }, time || this.time);
        },
        showFlashForever(message) {
            this.flashInfo.unshift({ message, title: 'Warning', state: 'warning' })
        },
        hideFlash() {
            this.flashInfo = []
        }
    },
};
</script>
<style scoped lang="scss">
.flash-holder {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
}
.flash-holder p {
    margin-bottom: 0;
}

.alert {
    display: flex;
    align-items: center;
    gap: 11px;
    width: 325px;
    min-height: 74px;
    z-index: 1060;
    pointer-events: none;
    border-radius: 10px;
    border: 0.5px solid var(--outline);
    background-color: var(--primary-bg);
    backdrop-filter: blur(15px);
    color: var(--primary-text);
    font-size: 13px;
    font-weight: 300;
    line-height: 16px;
    margin-bottom: 5px;
}

.alert-title {
    color: var(--primary-text);
    font-weight: 500;
    line-height: 16px;
    font-size: 13px;
    margin-bottom: 3px;
}
.alert-danger {
    padding: 10px 15px;
}
.alert-success, .alert-clock {
    padding: 10px 15px;
    min-width: 250px;
}
.alert-clock {
    align-items: flex-start;

    .alert-icon-container {
        margin-top: 10px;
    }
}
.alert-warning {
    padding: 10px 15px;
    min-width: 250px;
}

.alert-icon-container {
    img {
        width: 27px;
        height: 27px;
    }
}
.alert-message-container {
    flex: 1;
}
</style>
